import Consent from '@app/pages/consent/Consent';

export default Consent;
